import { CONSUMER_ID_MISSING, ID_FORMAT_UNSUPPORTED } from '../constants/vsb-enums';

// Takes regex from checkout-widget/src-widget/src/common/vco-component-identification/helpers/is-email.js
//eslint-disable-next-line max-len
export const emailRegex = /^((([a-z]|\d|[!#\$%&\*\+\-\?_])+(\.([a-z]|\d|[!#\$%&\*\+\-\?_])*)*)*)@((([a-z]|\d)|(([a-z]|\d)([a-z]|\d|-|\.|_)*([a-z]|\d)))\.)+(([a-z])|(([a-z])([a-z]|\d|-|\.|_)*([a-z])))$/i;

/**
 * In Vsb use cases, SRCi UI has not validated email.
 * We will validate on the orch level before calling network idLookups
 * @param {object} data IdentityLookup request object
 * @return {string} error string or empty string on valid email
 */
const validateIdentityLookupData = data => {
  const email = data?.identityValue;
  if (typeof email === 'undefined' || email === '') {
    return CONSUMER_ID_MISSING;
  } else if (typeof email === 'string') {
    return emailRegex.test(email) ? '' : ID_FORMAT_UNSUPPORTED;
  }
  return ID_FORMAT_UNSUPPORTED;
};

export default validateIdentityLookupData;
